export default "__VITE_ASSET__tjOdo_oZ__"